import React, { useEffect, useState, useRef} from 'react';
import { ApplicationState } from '../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useOktaAuth } from "@okta/okta-react";
import { getCallLogs, clearCallLogs } from '../../actions/CallLogAction';
import getApiUrl from '../../actions/ConfigurationAction';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DateTimePicker from 'react-datetime-picker';
import classes from './CallLog.module.css';
import { CallLogState } from '../../store/CallLogSlice';
import CallLogResults from './CallLogResults';
import CallLogCounts from './CallLogCounts';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import validator from 'validator';
import { defaultPageSize } from '../../common/utils';

export interface CallLogSearchParams {
    SiteId: string,
    StartDate: string,
    EndDate: string
}

const CallLog = () => {
    const { authState } = useOktaAuth();
    const dispatch = useDispatch();
    const configData: any = useSelector((state: ApplicationState) => state.Configuration.data);
    const calls: CallLogState = useSelector((state: ApplicationState) => state.CallLog);
    const basePath = window.location.origin;
    const controlIds: string[] = ['site', 'startDate', 'endDate'];
    const inputSite = useRef<HTMLInputElement | any>(null);
    const [siteError, setSiteError] = useState('');
    const [startDateError, setStartDateError] = useState(null || '');
    const [endDateError, setEndDateError] = useState(null || '');
    const [validated, setValidated] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [displayResults, setDisplayResults] = useState(false);
    const [startDateValue, setStartDateValue] = useState(new Date());
    const [endDateValue, setEndDateValue] = useState(new Date());
    const [params, setParams] = useState<CallLogSearchParams>({ SiteId: '', StartDate: '', EndDate: '' });
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (basePath !== '') {
            dispatch(getApiUrl(basePath));
        }
    }, []);

    useEffect(() => {
        if (calls.data !== null && isValid) {
            setDisplayResults(true);
        }
    }, [calls, validated])

    const validateDate = (dateIn: string) => {
        return validator.isDate(dateIn, { format: t('datepickerFormat') });
    }

    const setValidationErrors = () => {
        var failedValidation: boolean = false;
        if (inputSite.current.value === '') {
            setSiteError('Store# is required');
            console.log('Failed - Site Validation');
            failedValidation = true;
        }
        else {
            setSiteError('');
        }

        if (startDateValue === null) {
            setStartDateError('Start Date is required');
            failedValidation = true;
        }
        else if (!validateDate(moment(startDateValue).format(t('dateformat')))) {
            setStartDateError('Enter a valid Date');
            console.log('Failed - Start date Validation1');
            failedValidation = true;
        }
        else {
            setStartDateError('');
        }

        if (endDateValue === null) {
            setEndDateError('End Date is required');
            failedValidation = true;
        }
        else if (!validateDate(moment(startDateValue).format(t('dateformat')))) {
            setEndDateError('Enter a valid Date');
            console.log('Failed - End date Validation1');
            failedValidation = true;
        }
        else {
            setEndDateError('');
        }

        if (failedValidation) {
            setDisplayResults(false);
        }
    }

    const onSubmitFormHandler = async (event: any) => {
        event.preventDefault();
        setDisplayResults(false);
        if (isValid) {
            dispatch(clearCallLogs());
            setIsValid(false);
        }
        let form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidationErrors();
            setValidated(true);
            return;
        }

        setValidationErrors();
        setValidated(true);

        let cParams: CallLogSearchParams =
        {
            SiteId: inputSite.current.value,
            StartDate: moment(startDateValue).format(t('dateformat')),
            EndDate: moment(endDateValue).format(t('dateformat'))
        };
        setParams(cParams);

        if (authState !== null && authState.isAuthenticated && authState.accessToken !== undefined) {
            dispatch(getCallLogs(cParams, configData.apiUrl, authState.accessToken, 1, defaultPageSize, true));
            setIsValid(true);
        }
    }

    return (
        <>
            <div className="row p-0 m-0 w-100 justify-content-center">
                <div className="dialogbox dialogbox-md w-100">
                    <Form noValidate validated={validated} onSubmit={onSubmitFormHandler} id="frmCallLogSearch">
                        <Row>
                            <Form.Group as={Col} controlId={controlIds[0]}>
                                <Form.Label className={classes.formLabel}>Store#</Form.Label>
                                <Form.Control type="text" name={controlIds[0]} ref={inputSite} required isInvalid={!!siteError} />
                                <Form.Control.Feedback type="invalid">{siteError}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} controlId={controlIds[1]}>
                                <Form.Label className={classes.formLabel}>Start Date</Form.Label>
                                <DateTimePicker name={controlIds[1]} onChange={setStartDateValue} required value={startDateValue} format={t('datepickerFormat')} className="form-control" />
                                <Form.Control.Feedback type="invalid">{startDateError}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} controlId={controlIds[2]}>
                                <Form.Label className={classes.formLabel}>End Date</Form.Label>
                                <DateTimePicker name={controlIds[2]} onChange={setEndDateValue} required value={endDateValue} format={t('datepickerFormat')} className="form-control" />
                                <Form.Control.Feedback type="invalid">{endDateError}</Form.Control.Feedback>
                            </Form.Group>
                            <Col className="formActions d-flex">
                                <Button type="submit" className={classes.btnSearch}><FontAwesomeIcon icon={faSearch} /> Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            {
                displayResults && (
                    <div className="row">
                        <div className="col p-1">
                            <CallLogCounts subtotal={calls.subtotal} />
                            <CallLogResults data={calls.data} callLogParams={params} apiUrl={configData.apiUrl} />
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default CallLog;